import { render, staticRenderFns } from "./AddressType.vue?vue&type=template&id=2d2f6794&scoped=true&lang=pug"
import script from "./AddressType.vue?vue&type=script&lang=js"
export * from "./AddressType.vue?vue&type=script&lang=js"
import style0 from "./AddressType.vue?vue&type=style&index=0&id=2d2f6794&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2f6794",
  null
  
)

export default component.exports